import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async saveEventChartFilter(ctx, payload) {
    const savedData = JSON.parse(sessionStorage.getItem("inputFilter") || "{}");
    const mergedData = { ...savedData, ...payload };
    const filter = JSON.stringify(mergedData);
    sessionStorage.setItem("inputFilter", filter);
    ctx.commit("updateEventChartFilter", mergedData);
  },
  async saveOfficialChartFilter(ctx, payload) {
    const savedData = JSON.parse(sessionStorage.getItem("inputFilter") || "{}");
    const mergedData = { ...savedData, ...payload };
    const filter = JSON.stringify(mergedData);
    sessionStorage.setItem("inputFilter", filter);
    ctx.commit("updateOfficialChartFilter", payload);
  },
  async saveScoutChartFilter(ctx, payload) {
    const savedData = JSON.parse(sessionStorage.getItem("inputFilter") || "{}");
    const mergedData = { ...savedData, ...payload };
    const filter = JSON.stringify(mergedData);
    sessionStorage.setItem("inputFilter", filter);
    ctx.commit("updateScoutChartFilter", payload);
  },
  async removePerformanceChartFilter(ctx) {
    sessionStorage.removeItem("inputFilter");
    ctx.commit("updateEventChartFilter", {});
    ctx.commit("updateOfficialChartFilter", {});
    ctx.commit("updateScoutChartFilter", {});
  }
};

export default actions;
